import { render, staticRenderFns } from "./economicAnalysis.vue?vue&type=template&id=47ef7f9e&scoped=true&"
import script from "./economicAnalysis.vue?vue&type=script&lang=js&"
export * from "./economicAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./economicAnalysis.vue?vue&type=style&index=0&id=47ef7f9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ef7f9e",
  null
  
)

export default component.exports